@if (isLoading()) {
  <app-dashboard-list-card-skeleton>
    <ul class="flex-1 flex flex-col gap-2">
      <li class="flex gap-3 items-center">
        <ui-skeleton class="block size-5 flex-none rounded-md" />
        <ui-skeleton class="block h-3.5 flex-1 rounded-full" />
      </li>
      <li class="flex gap-3 items-center">
        <ui-skeleton class="block size-5 flex-none rounded-md" />
        <ui-skeleton class="block h-3.5 flex-1 rounded-full" />
      </li>
    </ul>
  </app-dashboard-list-card-skeleton>
} @else {
  <div
    class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 h-58"
  >
    @if (error()) {
      <app-error-component
        class="block h-full"
        (clickRetry)="onClickReload()"
        [enableRetry]="true"
      />
    } @else {
      <div class="flex gap-2 items-center">
        <h4 class="font-semibold leading-6 flex-1">
          {{ 'cockpit.dashboard.energyInterfacesCard.title' | transloco }}
          @if (totalEnergyInterfacesCount() > 0) {
            <span> ({{ totalEnergyInterfacesCount() }}) </span>
          }
        </h4>
        <ui-button
          mode="outlined"
          [iconOnly]="true"
          size="small"
          [routerLink]="['/organizations', organizationId(), 'energy-interfaces']"
        >
          <ng-icon name="heroArrowRight" size="20" class="!block" />
        </ui-button>
      </div>
      <ul class="flex-1 flex flex-col gap-2">
        @for (energyInterface of energyInterfaces(); track energyInterface.id) {
          <li
            class="flex gap-3 items-center text-sm leading-6 text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
          >
            @switch (energyInterface.data?.utilityType) {
              @case ('ELECTRICITY') {
                <span class="text-power dark:text-power-darkmode">
                  <ng-icon name="heroBolt" size="20" class="!block" />
                </span>
              }
              @case ('GAS') {
                <span class="text-gas dark:text-gas-darkmode">
                  <ng-icon name="heroFire" size="20" class="!block" />
                </span>
              }
            }
            <span class="line-clamp-1">
              {{ energyInterface.data?.label }}
            </span>
          </li>
        } @empty {
          <li
            class="block h-full w-full flex items-center justify-center text-center text-sm leading-6 text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
          >
            {{ 'cockpit.dashboard.energyInterfacesCard.emptyState' | transloco }}
          </li>
        }
      </ul>
      @if (totalEnergyInterfacesCount() > 3) {
        <ui-button
          mode="ghost"
          expand="full"
          size="small"
          [routerLink]="['/organizations', organizationId(), 'energy-interfaces']"
          >+{{ totalEnergyInterfacesCount() - 3 }}
          {{ 'cockpit.dashboard.energyInterfacesCard.more' | transloco }}</ui-button
        >
      }
    }
  </div>
}
